<template>
  <section class="q-downloads">
    <div class="container q-wrap">
      <div class="q-dl-card">
        <div class="q-dl-left">
          <h3 class="q-dl-title">Get Quick Quiz AI</h3>
          <p class="q-dl-sub">
            Choose your platform and download a specific version (stable, beta, or previous builds).
          </p>

          <div class="d-flex flex-wrap gap-3 mt-3">
            <!-- iOS dropdown (Vue-controlled) -->
            <div class="dropdown" :class="{ show: open === 'ios' }">
              <button
                class="btn q-store dropdown-toggle"
                type="button"
                :aria-expanded="open === 'ios' ? 'true' : 'false'"
                @click.stop="toggle('ios')"
              >
                <i class="bi bi-apple me-2"></i>
                <div class="q-store-text">
                  <div class="q-store-top">Download for</div>
                  <div class="q-store-bottom">iOS</div>
                </div>
              </button>

              <ul class="dropdown-menu q-dd" :class="{ show: open === 'ios' }">
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('iOS', 'v1.2.1 (Stable)')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">v1.2.1 (Stable)</span>
                      <span class="q-dd-chip">Latest</span>
                    </div>
                    <div class="q-dd-meta">Build 1021 • iOS 15+ • Jan 2026</div>
                  </button>
                </li>
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('iOS', 'v1.3.0 (Beta)')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">v1.3.0 (Beta)</span>
                      <span class="q-dd-chip q-dd-chip-soft">Beta</span>
                    </div>
                    <div class="q-dd-meta">Build 1030 • iOS 16+ • Jan 2026</div>
                  </button>
                </li>
                <li><hr class="dropdown-divider q-dd-divider" /></li>
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('iOS', 'v1.1.9')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">v1.1.9</span>
                    </div>
                    <div class="q-dd-meta">Build 1019 • iOS 15+ • Dec 2025</div>
                  </button>
                </li>
              </ul>
            </div>

            <!-- Android dropdown -->
            <div class="dropdown" :class="{ show: open === 'android' }">
              <button
                class="btn q-store dropdown-toggle"
                type="button"
                :aria-expanded="open === 'android' ? 'true' : 'false'"
                @click.stop="toggle('android')"
              >
                <i class="bi bi-google-play me-2"></i>
                <div class="q-store-text">
                  <div class="q-store-top">Get it for</div>
                  <div class="q-store-bottom">Android</div>
                </div>
              </button>

              <ul class="dropdown-menu q-dd" :class="{ show: open === 'android' }">
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('Android', 'v1.2.1 (Stable)')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">v1.2.1 (Stable)</span>
                      <span class="q-dd-chip">Latest</span>
                    </div>
                    <div class="q-dd-meta">APK 1021 • Android 9+ • Jan 2026</div>
                  </button>
                </li>
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('Android', 'v1.3.0 (Beta)')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">v1.3.0 (Beta)</span>
                      <span class="q-dd-chip q-dd-chip-soft">Beta</span>
                    </div>
                    <div class="q-dd-meta">APK 1030 • Android 10+ • Jan 2026</div>
                  </button>
                </li>
                <li><hr class="dropdown-divider q-dd-divider" /></li>
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('Android', 'v1.1.9')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">v1.1.9</span>
                    </div>
                    <div class="q-dd-meta">APK 1019 • Android 9+ • Dec 2025</div>
                  </button>
                </li>
              </ul>
            </div>

            <!-- Web dropdown -->
            <div class="dropdown" :class="{ show: open === 'web' }">
              <button
                class="btn q-store q-store-soft dropdown-toggle"
                type="button"
                :aria-expanded="open === 'web' ? 'true' : 'false'"
                @click.stop="toggle('web')"
              >
                <i class="bi bi-globe2 me-2"></i>
                <div class="q-store-text">
                  <div class="q-store-top">Use the</div>
                  <div class="q-store-bottom">Web App</div>
                </div>
              </button>

              <ul class="dropdown-menu q-dd" :class="{ show: open === 'web' }">
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('Web', 'Stable')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">Stable</span>
                      <span class="q-dd-chip">Recommended</span>
                    </div>
                    <div class="q-dd-meta">app.quickquiz.ai • Auto-updates</div>
                  </button>
                </li>
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('Web', 'Beta')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">Beta</span>
                      <span class="q-dd-chip q-dd-chip-soft">Preview</span>
                    </div>
                    <div class="q-dd-meta">beta.quickquiz.ai • New features first</div>
                  </button>
                </li>
                <li>
                  <button class="dropdown-item q-dd-item" type="button" @click="select('Web', 'PWA Install')">
                    <div class="q-dd-row">
                      <span class="q-dd-title">Install as PWA</span>
                    </div>
                    <div class="q-dd-meta">Works offline • Add to Home Screen</div>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <!-- Selected output -->
          <div v-if="selected" class="q-selected mt-3">
            <i class="bi bi-check2-circle me-2"></i>
            Selected: <span class="q-selected-strong">{{ selected.platform }}</span>
            — <span class="q-selected-strong">{{ selected.version }}</span>
          </div>

          <!-- ✅ Real "Download" button -->
          <div class="d-flex flex-wrap gap-3 mt-3">
            <button class="btn q-download" type="button" :disabled="!selected" @click="downloadTxt">
              <i class="bi bi-download me-2"></i>
              Download {{ selected ? selected.platform : "" }} {{ selected ? selected.version : "" }}
            </button>

            <button class="btn q-secondary" type="button" @click="selected = null">
              <i class="bi bi-x-circle me-2"></i>
              Clear selection
            </button>
          </div>

          <div class="q-hint mt-2">
            Tip: pick a platform/version above, then hit download (it generates a .txt file).
          </div>
        </div>

        <div class="q-dl-right">
          <div class="q-dl-stat">
            <div class="q-dl-stat-n">60s</div>
            <div class="q-dl-stat-t">setup time</div>
          </div>
          <div class="q-dl-stat">
            <div class="q-dl-stat-n">3</div>
            <div class="q-dl-stat-t">study modes</div>
          </div>
          <div class="q-dl-stat">
            <div class="q-dl-stat-n">∞</div>
            <div class="q-dl-stat-t">quizzes</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DownloadsSection",
  data() {
    return {
      selected: null,
      open: null, // 'ios' | 'android' | 'web' | null
    };
  },
  mounted() {
    window.addEventListener("click", this.onOutsideClick, { passive: true });
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("click", this.onOutsideClick);
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    toggle(which) {
      this.open = this.open === which ? null : which;
    },
    select(platform, version) {
      this.selected = { platform, version };
      this.open = null;
    },
    downloadTxt() {
      if (!this.selected) return;

      const now = new Date();
      const text =
        `Quick Quiz AI - Fake Download Package\n` +
        `====================================\n` +
        `Platform: ${this.selected.platform}\n` +
        `Version:  ${this.selected.version}\n` +
        `Generated: ${now.toISOString()}\n\n` +
        `This is a placeholder .txt download.\n` +
        `Replace this with real binaries/links later.\n`;

      const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      const safePlatform = String(this.selected.platform).toLowerCase().replace(/\s+/g, "-");
      const safeVersion = String(this.selected.version)
        .toLowerCase()
        .replace(/[^\w.-]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

      const a = document.createElement("a");
      a.href = url;
      a.download = `quick-quiz-ai-${safePlatform}-${safeVersion}.txt`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(url);
    },
    onOutsideClick(e) {
      const inside = e.target.closest(".dropdown");
      if (!inside) this.open = null;
    },
    onKeydown(e) {
      if (e.key === "Escape") this.open = null;
    },
  },
};
</script>

<style scoped>
.q-downloads { padding: 3rem 0; }
.q-wrap { max-width: 72rem; }

.q-dl-card{
  display:flex; gap:2rem; align-items:center;
  padding: 2rem;
  border-radius: 1.75rem;
  background: rgba(255,255,255,0.04);
  border: 0.0625rem solid rgba(255,255,255,0.08);
  overflow: visible;
}

.q-dl-left{ flex: 1 1 60%; }
.q-dl-right{
  flex: 1 1 40%;
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}

.q-dl-title{ font-weight: 950; color: rgba(255,255,255,0.96); margin: 0; }
.q-dl-sub{ color: rgba(255,255,255,0.72); line-height: 1.65; max-width: 90%; margin: 0.75rem 0 0; }

/* store button */
.q-store{
  display:flex; align-items:center; gap:0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 1.25rem;
  text-decoration:none;
  color: rgba(255,255,255,0.92);
  background: rgba(0,0,0,0.22);
  border: 0.0625rem solid rgba(255,255,255,0.12);
}
.q-store:hover{ background: rgba(255,255,255,0.06); }
.q-store i{ font-size: 1.5rem; }
.q-store-top{ font-size: 0.85rem; color: rgba(255,255,255,0.70); font-weight: 800; line-height: 1.1; }
.q-store-bottom{ font-size: 1.05rem; font-weight: 950; line-height: 1.1; }

.q-store-soft{
  background: linear-gradient(90deg, rgba(45,108,255,0.25), rgba(124,58,237,0.25), rgba(255,61,141,0.22));
  border-color: rgba(255,255,255,0.14);
}

/* Vue-controlled dropdown visibility */
.dropdown-menu { display: none; }
.dropdown-menu.show { display: block; }

/* dropdown menu styling */
.q-dd{
  min-width: 18rem;
  border-radius: 1.25rem;
  padding: 0.5rem;
  background: rgba(10, 12, 18, 0.96);
  border: 0.0625rem solid rgba(255,255,255,0.10);
  box-shadow: 0 1.75rem 3.5rem rgba(0,0,0,0.55);
  z-index: 2000;
}

.q-dd-item{
  border-radius: 1rem;
  padding: 0.85rem 0.9rem;
  color: rgba(255,255,255,0.90);
  text-align: left;
  width: 100%;
  background: transparent;
  border: 0;
}
.q-dd-item:hover{
  background: rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.95);
}

.q-dd-row{
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 0.75rem;
}

.q-dd-title{ font-weight: 950; }
.q-dd-meta{
  margin-top: 0.25rem;
  font-size: 0.9rem;
  color: rgba(255,255,255,0.65);
  font-weight: 700;
}

.q-dd-chip{
  font-size: 0.75rem;
  font-weight: 950;
  padding: 0.25rem 0.55rem;
  border-radius: 62.5rem;
  border: 0.0625rem solid rgba(255,255,255,0.16);
  background: rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.88);
}
.q-dd-chip-soft{
  background: rgba(255,61,141,0.12);
  border-color: rgba(255,61,141,0.25);
}

.q-dd-divider{
  border-top-color: rgba(255,255,255,0.12);
  margin: 0.35rem 0;
}

/* selected message */
.q-selected{
  margin-top: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 1.25rem;
  background: rgba(0,0,0,0.18);
  border: 0.0625rem solid rgba(255,255,255,0.10);
  color: rgba(255,255,255,0.78);
  font-weight: 800;
}
.q-selected-strong{ color: rgba(255,255,255,0.95); font-weight: 950; }

/* download button */
.q-download{
  border-radius: 62.5rem;
  padding: 0.75rem 1.25rem;
  font-weight: 950;
  color: #fff;
  border: 0;
  background: linear-gradient(90deg, #2d6cff 0%, #7c3aed 55%, #ff3d8d 120%);
  box-shadow: 0 1.125rem 2.25rem rgba(0, 0, 0, 0.35);
}
.q-download:hover{
  filter: brightness(1.06);
  transform: translateY(-0.0625rem);
}
.q-download:disabled{
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  filter: none;
}

.q-secondary{
  border-radius: 62.5rem;
  padding: 0.75rem 1.25rem;
  font-weight: 900;
  color: rgba(255,255,255,0.92);
  border: 0.0625rem solid rgba(255,255,255,0.18);
  background: rgba(255,255,255,0.04);
}
.q-secondary:hover{ background: rgba(255,255,255,0.08); }

.q-hint{
  color: rgba(255,255,255,0.62);
  font-weight: 700;
  font-size: 0.95rem;
}

/* stats */
.q-dl-stat{
  border-radius: 1.25rem;
  padding: 1rem;
  background: rgba(0,0,0,0.22);
  border: 0.0625rem solid rgba(255,255,255,0.10);
  text-align:center;
}
.q-dl-stat-n{ font-size: 1.35rem; font-weight: 950; color: rgba(255,255,255,0.95); }
.q-dl-stat-t{ font-weight: 850; color: rgba(255,255,255,0.68); }

@media (max-width: 62rem){
  .q-dl-card{ flex-direction: column; }
  .q-dl-right{ width: 100%; }
  .q-dl-sub{ max-width: 100%; }
  .q-dd{ width: 100%; min-width: 0; }
  .dropdown{ width: 100%; }
  .q-store{ width: 100%; justify-content: flex-start; }
  .q-download, .q-secondary { width: 100%; text-align: center; }
}
</style>
